var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 60,
    fill: "#F3E6F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3125 75C70.3125 77.5888 72.4112 79.6875 75 79.6875C77.5889 79.6875 79.6875 77.5888 79.6875 75C79.6875 72.4112 77.5889 70.3125 75 70.3125C72.4112 70.3125 70.3125 72.4112 70.3125 75Z",
    fill: "#870091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8703 88.1789C59.9721 89.5833 62.8981 89.5833 68.75 89.5833L81.25 89.5833C87.1019 89.5833 90.0279 89.5833 92.1298 88.1789C93.0397 87.5709 93.8209 86.7897 94.4289 85.8798C95.8334 83.7779 95.8334 80.8519 95.8334 75C95.8334 69.1481 95.8334 66.2221 94.4289 64.1203C93.8209 63.2103 93.0397 62.4291 92.1298 61.8211C90.0279 60.4167 87.1019 60.4167 81.25 60.4167H68.75C62.8981 60.4167 59.9721 60.4167 57.8703 61.8211C56.9604 62.4291 56.1791 63.2103 55.5711 64.1203C54.1667 66.2221 54.1667 69.1481 54.1667 75C54.1667 80.8519 54.1667 83.7779 55.5711 85.8798C56.1791 86.7897 56.9604 87.5709 57.8703 88.1789ZM75 82.8125C70.6853 82.8125 67.1875 79.3147 67.1875 75C67.1875 70.6853 70.6853 67.1875 75 67.1875C79.3147 67.1875 82.8125 70.6853 82.8125 75C82.8125 79.3147 79.3147 82.8125 75 82.8125ZM61.4584 82.8125C60.5954 82.8125 59.8959 82.113 59.8959 81.25L59.8959 68.75C59.8959 67.8871 60.5954 67.1875 61.4584 67.1875C62.3213 67.1875 63.0209 67.8871 63.0209 68.75L63.0209 81.25C63.0209 82.113 62.3213 82.8125 61.4584 82.8125ZM86.9792 81.25C86.9792 82.113 87.6787 82.8125 88.5417 82.8125C89.4046 82.8125 90.1042 82.113 90.1042 81.25V68.75C90.1042 67.8871 89.4046 67.1875 88.5417 67.1875C87.6787 67.1875 86.9792 67.8871 86.9792 68.75V81.25Z",
    fill: "#870091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceHover);
export default __webpack_public_path__ + "static/media/Finance-hover.8e7a2c9908cc379130b3d88264a3a662.svg";
export { ForwardRef as ReactComponent };